// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAcquireScanModeRaster_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.92505 17.486L5.2298 14.1813C4.35194 11.7146 4.90027 8.85396 6.8748 6.87944C8.84932 4.90491 11.71 4.35658 14.1766 5.23444L17.4814 1.92969L18.5421 2.99035L15.5997 5.93268C16.016 6.19978 16.4102 6.51536 16.7743 6.87944C17.2657 7.37085 17.6688 7.91716 17.9835 8.49862L21.0169 5.46522L22.0776 6.52588L18.587 10.0165C19.2106 12.3518 18.6064 14.9468 16.7743 16.7789C14.9422 18.611 12.3472 19.2153 10.0119 18.5916L6.52124 22.0822L5.46058 21.0216L8.49399 17.9882C7.91252 17.6734 7.36622 17.2703 6.8748 16.7789C6.51073 16.4149 6.19514 16.0207 5.92804 15.6044L2.98571 18.5467L1.92505 17.486ZM17.2996 11.3039C17.45 12.881 16.9213 14.5106 15.7136 15.7183C14.5059 16.926 12.8763 17.4546 11.2993 17.3042L17.2996 11.3039ZM10.1147 16.3675L9.61479 16.8674C9.00531 16.6002 8.43438 16.2172 7.93546 15.7183C7.56775 15.3506 7.263 14.9438 7.02119 14.5112L8.30297 13.2294L10.1147 16.3675ZM11.2128 15.2694L12.3109 14.1713L10.4991 11.0333L9.40104 12.1314L11.2128 15.2694ZM12.9634 6.44772C11.2052 6.07737 9.30072 6.57483 7.93546 7.94009C6.57019 9.30536 6.07273 11.2098 6.44308 12.968L12.9634 6.44772ZM12.6953 8.83713L14.507 11.9751L13.4089 13.0732L11.5972 9.93521L12.6953 8.83713ZM13.7933 7.73906L14.5066 7.02583C14.9391 7.26764 15.3459 7.57239 15.7136 7.94009C16.2126 8.43902 16.5956 9.00995 16.8627 9.61943L15.6051 10.8771L13.7933 7.73906Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAcquireScanModeRaster is a generated icon component.
 */
let IconMedAcquireScanModeRaster = IconMedAcquireScanModeRaster_1 = class IconMedAcquireScanModeRaster extends IconBaseElement {
    render() {
        return html `${IconMedAcquireScanModeRaster_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAcquireScanModeRaster.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedAcquireScanModeRaster = IconMedAcquireScanModeRaster_1 = __decorate([
    customElement('zui-icon-med-acquire-scan-mode-raster')
], IconMedAcquireScanModeRaster);
export { IconMedAcquireScanModeRaster };
